import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    img {
        width: 100%;
        height: 30em;
        object-fit: cover;
    }

    h1 {
        margin-bottom: 0;
        color: var(--text-color);
    }

    hr {
        width: 100%;
    }

    .container {
        display: block;
        height: 100%;
        isolation: isolate;
    }

    .banner {
        display: block;
        position: relative;
    }

    .edit-banner-photo {
        position: absolute;
        right: 1em;
        bottom: 1em;
    }

    .banner-footer {
        gap: 0;
        padding-left: 1em;
        padding-right: 1em;
    }

    .view-button {
        font-size: 1.1em;
        font-weight: 450;
        color: #666;
        padding: 0.8em;
    }

    .view-button:hover:not(.active) {
        background-color: #f2f2f2;
        border-radius: 1em;
    }

    .active {
        color: blue;
        border-bottom: 2px solid blue;
    }

    ds-close-button {
        position: absolute;
        top: 2em;
        right: 2em;
    }

    ds-social-links {
        --icon-color: #666;
    }

    sl-avatar {
        --size: 4.5em;
        margin-top: -2em;
    }

    sl-avatar::part(image) {
        border: 3px solid white;
    }

    @media only screen and (max-width: 600px) {
        img {
            height: 20em;
        }
    }
`;
